import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { LayoutGrid, LayoutList } from "lucide-react";

export const ProjectsToolbar = ({ q, onSearch, sortKey, onSortKey, sortDir, onSortDir, view, onView }) => (
  <>
    <div className="relative w-full sm:w-auto sm:flex-none min-w-0">
      <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <Input data-testid="project-search" placeholder="Search projects…" value={q}
        onChange={(e) => onSearch(e.target.value)} className="pl-9 w-full min-w-0 sm:w-64" />
    </div>
    <Select value={sortKey} onValueChange={onSortKey}>
      <SelectTrigger className="w-40 h-9" data-testid="sort-key"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="updated_at">Last Modified</SelectItem>
        <SelectItem value="name">Project Name</SelectItem>
        <SelectItem value="client_name">Client Name</SelectItem>
        <SelectItem value="folder_name">Folder Name</SelectItem>
        <SelectItem value="created_at">Creation Date</SelectItem>
      </SelectContent>
    </Select>
    <Button variant="outline" size="sm" className="h-9 px-2.5" data-testid="sort-dir"
      title={sortDir === "asc" ? "Ascending" : "Descending"}
      onClick={() => onSortDir(sortDir === "asc" ? "desc" : "asc")}>{sortDir === "asc" ? "↑" : "↓"}</Button>
    <div className="flex rounded-md border border-border overflow-hidden">
      <button data-testid="view-list" onClick={() => onView("list")} title="List view"
        className={`flex items-center gap-1.5 px-3 h-9 text-xs font-semibold ${view === "list" ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:text-foreground"}`}>
        <LayoutList size={14} /> List</button>
      <button data-testid="view-grid" onClick={() => onView("grid")} title="Grid view"
        className={`flex items-center gap-1.5 px-3 h-9 text-xs font-semibold ${view === "grid" ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:text-foreground"}`}>
        <LayoutGrid size={14} /> Grid</button>
    </div>
  </>
);
